import User from './User'

export type Status = 'analysing' | 'proposal' | 'pending' | 'approved' | 'closed' | 'refused'

export default interface Realty {
  id: number
  status: Status
  created_at: string
  type: string
  type_id: string
  custom_type: string
  registration_number: string
  fiscal_information: string
  registry_office: string
  amout: string
  numbers: string
  blocks: string
  owes_since: number
  address: any
  proposal_amount: number | null
  possibleStatus: Status[] | null
  proposals: any[] | null
  statusHistory: {
    status: Status
    current: Status
    created_at: string
  }[]
  user: User
  uploads: {
    id: number
    type: string
    name: string
    url: string
  }[]
}

export const STATUS: { [key in Status]: string } = {
  analysing: 'Em Análise',
  proposal: 'Proposta Feita',
  pending: 'Pendente de Documentos',
  approved: 'Proposta Aceita',
  closed: 'Negociação Fechada',
  refused: 'Negociação Recusada',
}

export const STATUS_ORDER: { [key in Status]: number } = {
  analysing: 1,
  proposal: 2,
  pending: 3,
  approved: 4,
  closed: 5,
  refused: 6,
}

export const canUpdateRealty = (realty: Realty) => {
  if (STATUS_ORDER[realty.status] > STATUS_ORDER['pending' as Status]) {
    return false
  }
  return true
}

export const STATUS_COLORS: { [key in Status]: string } = {
  refused: 'red',
  pending: 'blue',
  approved: 'green',
  closed: 'green',
  analysing: 'blue',
  proposal: 'blue',
}
